import { useQuery } from '@tanstack/react-query'
import { useDataProvider } from 'react-admin'

type DocumentImageResponse = {
  data: {
    id: string
    src: string
  }
}

type DocumentImageDataProvider = {
  getDocumentImage: (imageId: string) => Promise<DocumentImageResponse>
}

const useIdentityDocumentImage = (documentImageId?: string) => {
  const dataProvider = useDataProvider()

  return useQuery({
    queryKey: ['user-document-image', documentImageId],
    queryFn: () =>
      (dataProvider as typeof dataProvider & DocumentImageDataProvider).getDocumentImage(documentImageId ?? ''),
    enabled: Boolean(documentImageId),
  })
}

export default useIdentityDocumentImage
